<div class="modal-header bg-soft-info p-3">
    <h5 *ngIf='newModel' class="modal-title" id="exampleModalLabel" i18n="@@">Add Event</h5>
    <h5 *ngIf='!newModel' class="modal-title" id="exampleModalLabel" i18n="@@">
        <span *ngIf="isOwnerOfEvent == true">
            Edit -
        </span>
        {{model.title}}
    </h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>

<div *ngIf=(showPreviewModel) class="card-body p-3">
    <div *ngIf="isOwnerOfEvent == true" class="text-end">
        <a class="btn btn-sm btn-soft-primary" id="edit-event-btn" data-id="edit-event"
            (click)="showPreviewModel = !showPreviewModel" role="button">Edit</a>
    </div>
    <div class="event-details">
        <div class="d-flex mb-2">
            <div class="flex-grow-1 d-flex align-items-center fs-20 overflow-auto">
                {{model.title}}
            </div>
        </div>
        <div class="d-flex mb-2">
            <div class="flex-grow-1 d-flex align-items-center">
                <div class="flex-grow-1 d-flex align-items-center gap-1 ">
                    <h6 class="text-muted d-block fw-semibold mb-0" id="event-start-date-tag">
                        {{model.date.from | date:'dd MMMM'}}
                        {{model.date.from | date: 'h:mm a'}}
                        -
                        <span *ngIf=!eventOccursWithinOneDay>
                            {{model.date.to | date: 'dd MMMM'}}
                        </span>
                        {{model.date.to | date: 'h:mm a'}}
                    </h6>
                </div>
            </div>


        </div>

        <div *ngIf="model.location" class="d-flex align-items-center mb-2">
            <hr>
            <div class="flex-shrink-0 me-3">
                <i class="ri-map-pin-line text-muted fs-16"></i>
            </div>
            <div class="flex-grow-1">
                <h6 class="d-block fw-semibold mb-0"> <span id="event-location-tag">{{model.location}}</span></h6>
            </div>
        </div>
        <div *ngIf="model.description" class="d-flex mb-3">
            <hr>
            <div class="flex-grow-1">

                <app-rich-text-displayer [textToDisplay]="model.description"></app-rich-text-displayer>

            </div>
        </div>

    </div>

    <div *ngIf="isOwnerOfEvent == false" class="card-body mb-3">
        <div class="col-md-auto ms-auto d-flex justify-content-between">
            <div>
                <div class="d-flex align-items-center gap-2">
                    <div class="btn-group" ngbDropdown>
                        <button class="btn btn-primary">{{statusText(userEventStatus.value)}}</button>
                        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                        </button>

                        <ul class="dropdown-menu" ngbDropdownMenu>
                            <li *ngFor="let option of userEventStatusOptions; index as i ">
                                <a class="dropdown-item" href="javascript:void(0);" (click)="userStatusUpdate(option)">
                                    <span i18n="@@">{{option.dropdownText}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-12">
        <hr>
        <div class="mb-3">
            <label i18n="@@">Organizer</label>
            <div class="d-flex align-items-center">
                <div class="flex-shrink-0 gap-2">
                    <div style=" position:relative; display:inline-block;">
                        <img [src]="profileImageURL" alt="" class=" avatar-xs rounded-circle me-2"
                            style="  object-fit:cover;">
                        <span class="rounded-circle" style=" width:0.75rem;
                        height:0.75rem;
                        top: 1.25rem;
                        right: 0.5rem;
                        border:1px solid var(--vz-card-color);
                        position:absolute;">
                        </span>
                    </div>
                </div>
                {{organizerName}}
            </div>
        </div>
    </div>

    <div *ngIf="model.attendees && model.attendees.length > 0" class="col-lg-12">
        <hr>
        <div>
            <label i18n="@@">Attendees</label>
            <div class="d-flex align-items-center mb-2" *ngFor="let attendee of model.attendees">

                <img [src]="attendeeProfile" alt="" class=" avatar-xs rounded-circle me-2" style=" object-fit:cover;">
                <span class="rounded-circle" style=" width:0.75rem;
                    height:0.75rem;
                    top: 1.25rem;
                    right: 0.5rem;
                    border:1px solid var(--vz-card-color);
                    position:absolute;">
                </span>

                <div class="d-flex" style="flex-direction: column !important;">
                    {{attendee.name}}
                    <span *ngIf="attendee.status" class="fs-12 p-0 bg-transparent font-size-12"
                        style="cursor:default !important; " [ngClass]=statusTextClass(attendee.status)>
                        {{statusText(attendee.status)}}
                    </span>
                </div>
            </div>
        </div>
    </div>

</div>


<div *ngIf="(showPreviewModel==false) || newModel" class="card-body p-3">
    <div *ngIf='!newModel' class="text-end">
        <a class="btn btn-sm btn-soft-primary" id="edit-event-btn" data-id="edit-event"
            (click)="showPreviewModel = !showPreviewModel" role="button">Cancel</a>
    </div>
    <div class="row event-form">

        <div class="col-12 col-lg-8">
            <div class="mb-3">
                <label i18n="@@">Title</label>
                <input required #eventName="ngModel" mask='A* A* A* A* A* A*' [dropSpecialCharacters]="false"
                    [ngClass]="{ 'is-invalid': (eventName.invalid && ((eventName.dirty || eventName.touched) || submitted == true))}"
                    class="form-control" type="text" placeholder="Add title" i18n-placeholder="@@"
                    [(ngModel)]="model.title" (keypress)="modalEdited = true" />
                <div *ngIf="(eventName.invalid && ((eventName.dirty || eventName.touched) || submitted == true))"
                    class='invalidInputTextMessage'>
                    <div *ngIf="eventName.errors?.['required']">
                        <div i18n="@@"> Title is Required</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="mb-3">
                <label class="form-label">Color</label>
                <app-ng-select-layout [placeHolderText]="'Select Type'" [invalidText]="'Type Required'"
                    [(model)]="model.category" [items]="eventStatusOptions" [includeValidation]="true"
                    [submitted]="submitted"></app-ng-select-layout>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="mb-3">
                <label i18n="@@">Attendees</label>
                <app-attendees-selection [selectedModelsArray]="model.attendees" class="d-block form-control p-0"
                    style="padding-left: 4px !important;" [searchFieldStyle]="true"
                    (updateAttendees)="updateAttendees($event)"></app-attendees-selection>
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <div class="mb-3">
                <label>Event Date</label>

                <div class="d-flex align-items-center gap-2 form-control" style="height:2.25rem ;"
                    [ngClass]="{ 'is-invalid': (eventDate.invalid && ((eventDate.dirty || eventDate.touched) || submitted == true))}">
                    <input class=" flex-grow-1 form-control " style="border-width: 0; padding: 0 !important; "
                        type="text" placeholder="Select date/range" [(ngModel)]="model.date" required #eventDate="ngModel"
                        mwlFlatpickr [disableMobile]="true" [convertModelValue]="true" mode="range" altFormat="d M, Y" dateFormat="d M, Y">
                    <i *ngIf="model.date" class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                        style="font-size: 1rem;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        color: #878a99;" (click)="model.date = ''"></i>
                </div>

                <div *ngIf="(eventDate.invalid && ((eventDate.dirty || eventDate.touched) || submitted == true))"
                    class='invalidInputTextMessage'>
                    <div *ngIf="eventDate.errors?.['required']">
                        <div i18n="@@"> Date is Required</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-12 col-lg-2">
            <div class="mb-3">
                <label class="form-label">All Day Event</label>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" [checked]="model.allDayEvent"
                        (change)="model.allDayEvent = !model.allDayEvent" />
                </div>

            </div>
        </div>
        <div class="col-12 col-lg-6" id="event-time" [ngStyle]="{'display': (model.allDayEvent) ? 'none': ''} ">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Start Time</label>
                        <div class="input-group">
                            <input class="form-control " type="text" [(ngModel)]="model.startTime" required
                                #eventStart="ngModel"
                                [ngClass]="{ 'is-invalid': (eventStart.invalid && ((eventStart.dirty || eventStart.touched) || submitted == true ))}"
                                placeholder="Select start time" mwlFlatpickr [disableMobile]="true" [noCalendar]="true" [enableTime]="true"
                                [dateFormat]="'H:i'">
                            <span class="input-group-text"><i class="ri-time-line"></i></span>
                        </div>
                        <div *ngIf="(eventStart.invalid && ((eventStart.dirty || eventStart.touched) || submitted == true))"
                            class='invalidInputTextMessage'>
                            <div *ngIf="eventStart.errors?.['required']">
                                <div i18n="@@"> Start Time is Required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="mb-3">
                        <label class="form-label">End Time</label>
                        <div class="input-group">
                            <input class="form-control flatpickr-input" type="text" [(ngModel)]="model.endTime" required
                                #eventEnd="ngModel"
                                [ngClass]="{ 'is-invalid': ((eventEnd.invalid && ((eventEnd.dirty || eventEnd.touched) || submitted == true )) || invalidTimeRange == true)}"
                                placeholder="Select end time" mwlFlatpickr [disableMobile]="true" [noCalendar]="true" [enableTime]="true"
                                [dateFormat]="'H:i'">
                            <span class="input-group-text"><i class="ri-time-line"></i></span>
                        </div>
                        <div *ngIf="(eventEnd.invalid && ((eventEnd.dirty || eventEnd.touched) || submitted == true))"
                            class='invalidInputTextMessage'>
                            <div *ngIf="eventEnd.errors?.['required']">
                                <div i18n="@@"> End Time is Required</div>
                            </div>
                        </div>
                        <div *ngIf="(invalidTimeRange == true)" class='invalidInputTextMessage'>
                            <div i18n="@@"> End Time is Before Start Time</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="mb-3">
                <label i18n="@@">Location</label>
                <input #eventLocation="ngModel" class="form-control" type="text" placeholder="Add location"
                    i18n-placeholder="@@" [(ngModel)]="model.location" (keypress)="modalEdited = true" />

            </div>
        </div>
        <div class="col-lg-12">
            <div class="mb-3">
                <label i18n="@@">Description</label>
                <div class="ck-editor-reverse">
                    <!-- <ckeditor [editor]="editor" [config]="editorConfig" [(ngModel)]="model.description">
                    </ckeditor> -->
                    <app-rich-text-editor [textToEdit]="model.description"
                    (textToEditChange)="updateText($event)">
                </app-rich-text-editor>
                </div>
            </div>
        </div>

        <div class="hstack d-flex gap-2 justify-content-end">
            <button *ngIf="!newModel" (click)="delete()" [disabled]="disableEditing" type="button"
                class="btn btn-soft-danger" id="btn-delete-event"><i class="ri-close-line align-bottom"></i>
                Delete</button>
            <button *ngIf="newModel" (click)="onSave()" [disabled]="disableEditing" type="button"
                class="btn btn-success " id="add-btn" i18n="@@">Add
                Event</button>
            <button *ngIf="!newModel" (click)="onSave()" [disabled]="disableEditing" type="button"
                class="btn btn-success " id="add-btn" i18n="@@">Update
                Event</button>
        </div>


    </div>

</div>